export default {
  uploading: 'Subiendo',
  cancel: 'Cancelar',
  modelTrainingProgress: 'Progreso del Entrenamiento del Modelo',
  stage: 'Etapa',
  deliverables: 'Entregables',
  status: 'Estado',
  actions: 'Acciones',
  completed: 'Completado',
  pending: 'Pendiente',
  approveStage: 'Aprobar Etapa',
  undoApproval: 'Deshacer aprobación',
  upload: 'Subir',
  deleteFileConfirm: '¿Está seguro de que desea eliminar el archivo?',
  unsupportedFiles: 'Estos archivos se omitieron porque solo se pueden subir reportes HTML y planillas Excel (.xlsx, .xls): {files}',
  errorUploadingFile: 'Error al subir el archivo.',
  viewReport: 'Ver reporte',
  downloadDeliverable: 'Descargar {name}',
  deliverableKinds: {
    report: 'Reporte',
    modelReport: 'Excel Model Report',
    inputsReport: 'Inputs Report'
  },
  assignTitle: 'Subir a {stage}',
  assignHint: 'Asigna cada planilla a su tipo antes de subirla. Una sola planilla, o un par en el que solo una tiene "input" en el nombre, viene preasignada.',
  assignPlaceholder: 'Elige un tipo',
  tooManySpreadsheets: 'Se pueden subir como máximo {max} planillas a la vez (un Excel Model Report y un Inputs Report). No se subió nada.',
  assignRepeated: 'Hay más de un archivo asignado como {kinds}: se subirán como versiones consecutivas.',
  uploadingCount: '({current} de {total})',
  sendFeedback: 'Enviar feedback',
  feedbackUnavailable: 'Disponible cuando {stage} tenga un reporte o una planilla',
  feedbackStaff: 'Equipo de NG',
  feedbackFirst: 'Primer feedback: {date}',
  feedbackLast: 'Último: {date}'
}
